import(/* webpackMode: "eager" */ "/vercel/path0/src/app/social-platform/page.tsx");
